import { DefaultApi } from '../api';
import {
  SpouseStatusResponse,
  AddDocumentPayload,
  UpdateSpousePayload,
  SelfieAnalysisPayload,
} from '../types';
import { SelfieAnalysisResponse } from './types';

export const getData = (id: string) =>
  DefaultApi.request<SpouseStatusResponse>(`/spouses/${id}`, {
    method: 'GET',
  });

export const selfieAnalysis = (id: string, payload: SelfieAnalysisPayload) =>
  DefaultApi.request<SelfieAnalysisResponse>(`/spouses/${id}/selfie-analysis`, {
    method: 'POST',
    data: payload,
  });

export const addDocument = (id: string, payload: AddDocumentPayload) =>
  DefaultApi.request<SpouseStatusResponse>(`/spouses/${id}/documents`, {
    method: 'POST',
    data: payload,
  });

export const updateSpouseData = (id: string, payload: UpdateSpousePayload) =>
  DefaultApi.request<any>(`/spouses/${id}`, {
    method: 'PATCH',
    data: payload,
  });
